<template>
  <div v-loading="loading">
    <el-descriptions border size="small" :column="1">
      <el-descriptions-item
        :label="$l('form_label_processDictName') || '字典名称'"
        :labelStyle="{ width: '100px' }"
      >
        {{ dictFormData.processDictName || '' }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions border size="small" :column="2" class="bottom-desc">
      <el-descriptions-item
        :label="$l('form_label_masterCategory') || '主分类'"
        :labelStyle="{ width: '100px' }"
      >
        {{ dictFormData.masterCategoryName || '' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('form_label_category') || '明细分类'"
        :labelStyle="{ width: '100px' }"
      >
        {{ dictFormData.categoryName || '' }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions border size="small" :column="1" class="bottom-desc">
      <el-descriptions-item
        :label="$l('form_label_pdPerson') || '工艺师'"
        :labelStyle="{ width: '100px' }"
      >
        {{ dictFormData.pdPersonName || '' }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
export default {
  props: { pdProcessDictCode: { type: String, default: '' } },
  data() {
    return {
      dictFormData: {},
      loading: false,
    }
  },
  mounted() {
    this.loadDict()
  },
  methods: {
    async loadDict() {
      if (!this.pdProcessDictCode) return
      const res = await this.$api
        .processDictionaryDetailApi({
          pdProcessDictCode: this.pdProcessDictCode,
        })
        .catch(() => {})
      this.dictFormData = res.body || {}
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
}
</style>
